import styled from '@emotion/styled';
import BaseCard, {
  Content as BaseContent
} from '@portalterreno/react-ui-core/Card';

const Card = styled(BaseCard)({
  display: 'block',
  boxShadow: 'none'
});

const Content = styled(BaseContent)({
  padding: 0,
  margin: '0 auto'
});

const values = { ...BaseCard, Card, Content };

export default values;
